"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackChartIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const StackChartIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "3,3,18,18" }),
    react_1.default.createElement("path", { d: "M4,14v1v3h4v-3v-1V9H4V14z M7,17H5v-2h2V17z M5,10h2v4H5V10z M10,11v1v6h4v-6v-1V6h-4V11z M13,17h-2v-5h2V17z M11,7h2v4h-2   V7z M16,3v11v1v3h4v-3v-1V3H16z M19,17h-2v-2h2V17z M17,14V4h2v10H17z M21,21H3v-1h18V21z" })));
exports.StackChartIcon = StackChartIcon;
exports.default = exports.StackChartIcon;
